/**
 * Shared between the server gate (throws) and client error boundaries (branch).
 * Kept import-free so client bundles never pull the breaker/logger.
 */
export const UPSTREAM_UNAVAILABLE_DIGEST = 'UPSTREAM_UNAVAILABLE';

export function isUpstreamUnavailableError(error: { digest?: string } | null | undefined): boolean {
  return error?.digest === UPSTREAM_UNAVAILABLE_DIGEST;
}
